export enum EntityType {
    ACCOUNT = 'account',
    ANSWER = 'answer',
    ANY = 'any',
    ATTRIBUTE = 'attribute',
    ATTRIBUTE_VALUE = 'attribute_value',
    AUDIT_LOG = 'audit_log',
    BASKET = 'basket',
    BASKET_ITEM = 'basket_item',
    BUDGET = 'budget',
    BUDGET_ENTITY = 'budget_entity',
    BUDGET_RULE = 'budget_rule',
    BUDGET_USE = 'budget_use',
    BUNDLE = 'bundle',
    CERTIFICATE = 'certificate',
    CERTIFICATE_REQUIREMENT = 'certificate_requirement',
    COLLI = 'colli',
    COLLI_CONTENT = 'colli_content',
    COLLI_TIMER = 'colli_timer',
    CONSTRAINT = 'constraint',
    COST_CENTER = 'cost_center',
    COST_CENTER_ENTITY = 'cost_center_entity',
    CUSTOM_ROLE = 'custom_role',
    DECEASED = 'deceased',
    DEVICE = 'device',
    DOCKER_IMAGE = 'docker_image',
    DOCUMENT = 'document',
    ENTITY_SHARE = 'entity_share',
    EQUIPMENT = 'equipment',
    EQUIPMENT_CERTIFICATE = 'equipment_certificate',
    EQUIPMENT_COUNT = 'equipment_count',
    EQUIPMENT_GROUP = 'equipment_group',
    EQUIPMENT_PROBLEM = 'equipment_problem',
    EQUIPMENT_TIMER = 'equipment_timer',
    EQUIPMENT_USE = 'equipment_use',
    EQUIPMENT_VARIABLE = 'equipment_variable',
    EVENT = 'event',
    EXTERNAL_ENTITY_MAPPING = 'external_entity_mapping',
    FUNCTIONALITY = 'functionality',
    GROUP = 'group',
    GROUP_MEMBER = 'group_member',
    IDENTIFICATION = 'identification',
    INBOX_MESSAGE = 'inbox_message',
    INVITE = 'invite',
    IOT = 'iot',
    IOT_TIMER = 'iot_timer',
    IOT_TROUBLESHOOT = 'iot_troubleshoot',
    LABEL = 'label',
    LABEL_CONTENT = 'label_content',
    LABEL_TEMPLATE = 'label_template',
    LICENSE = 'license',
    LOCKER = 'locker',
    MODULE = 'module',
    MODULE_TEMPLATE = 'module_template',
    NOTIFICATION_EMAIL = 'notification_email',
    NOTIFICATION_TEMPLATE = 'notification_template',
    ORDER = 'order',
    ORDER_ITEM = 'order_item',
    OUTBOX_MESSAGE = 'outbox_message',
    PACKAGE = 'package',
    PACKAGE_TIMER = 'package_timer',
    PAYMENT = 'payment',
    PIN_CODE = 'pin_code',
    PLAYLIST = 'playlist',
    PLAYLIST_ITEM = 'playlist_item',
    PROBLEM = 'problem',
    PROBLEM_ENTITY = 'problem_entity',
    PRODUCT = 'product',
    PRODUCT_ATTRIBUTE = 'product_attribute',
    PRODUCT_CATEGORY = 'product_category',
    PRODUCT_GROUP = 'product_group',
    QUESTION = 'question',
    QUESTIONNAIRE = 'questionnaire',
    REPORT = 'report',
    REPORT_JOB = 'report_job',
    REPORT_SCHEDULE = 'report_schedule',
    REVIEW = 'review',
    REVIEW_TRANSACTION = 'review_transaction',
    ROLE = 'role',
    SETTING = 'setting',
    SLOT = 'slot',
    SLOT_TEMPLATE = 'slot_template',
    SPOT = 'spot',
    SSO_PROVIDER = 'sso_provider',
    STOCK = 'stock',
    STOCK_MOVEMENT = 'stock_movement',
    STOCK_REQUIREMENT = 'stock_requirement',
    SUPPLIER = 'supplier',
    TRANSACTION = 'transaction',
    TRANSACTION_ACTOR = 'transaction_actor',
    TRANSACTION_ATTACHMENT = 'transaction_attachment',
    TRANSACTION_COUNT = 'transaction_count',
    TRANSACTION_RULE = 'transaction_rule',
    TRANSACTION_TIMER = 'transaction_timer',
    TRANSACTION_USER = 'transaction_user',
    USER = 'user',
    USER_CERTIFICATE = 'user_certificate',
    USER_GROUP = 'user_group',
    USER_INTERFACE = 'user_interface',
    USER_INTERFACE_BUTTON = 'user_interface_button',
    WIZARD = 'wizard',
    WIZARD_STEP = 'wizard_step',
    WORKFLOW = 'workflow',
    WORKFLOW_FIELD = 'workflow_field',
    WORKFLOW_STEP = 'workflow_step',

    // Not known by backend
    ACCESS_LOG = 'access_log',
    ACTUATOR = 'actuator',
    ALL = '*',
    APPLICATION = 'application',
    AUDIT = 'audit',
    AUTHORIZATION = 'authorization',
    BADGE = 'badge',
    BARCODE = 'barcode',
    BASIC_AUTH = 'basic_auth',
    BRANDING = 'branding',
    CATEGORY = 'category',
    CHANGE = 'change',
    DEFECT_LOG = 'defect_log',
    DOCUMENT_ENTITY = 'document_entity',
    GROUPED_STOCK_AGGREGATION = 'grouped_stock_aggregation',
    HELP = 'help',
    IMPEX = 'impex',
    IMPORT = 'import',
    IMPORT_JOB = 'import_job',
    IMPORT_JOB_ERROR = 'import_job_error',
    IMPORT_JOB_LOCK = 'import_job_lock',
    INTEGRATION_TEST = 'integration_test',
    JOB = 'job',
    LABEL_TEMPLATE_CONTENT = 'label_template_content',
    LOGO = 'logo',
    MEDIA_FILE = 'media_file',
    MEMBER = 'member',
    MOBILE = 'mobile',
    MOVEMENT = 'movement',
    NOTIFICATION = 'notification',
    NOTIFICATION_CONTENT = 'notification_content',
    OUTPUT = 'output',
    PERMISSION = 'permission',
    PRODUCT_CATEGORY_ATTRIBUTE = 'product_category_attribute',
    RAKINDA = 'rakinda',
    REQUIREMENT = 'requirement',
    RULE = 'rule',
    SCHEDULE = 'schedule',
    SCREEN = 'screen',
    SEED = 'seed',
    SENSOR = 'sensor',
    SERVER = 'server',
    SLOT_STOCK_AGGREGATION = 'slot_stock_aggregation',
    STEP = 'step',
    TAG = 'tag',
    TEMPLATE = 'template',
    TEST = 'test',
    TRANSLATION = 'translation',
    UNDEFINED = '',
    UNKNOWN = 'unknown'
}
